import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md-expandable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_markdown_excerpt = _resolveComponent("ontos-markdown-excerpt")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_markdown_viewer = _resolveComponent("markdown-viewer")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ontos_markdown_excerpt, {
      value: _ctx.value,
      full: _ctx.full,
      class: _normalizeClass(["md-expandable-text", {'md-expandable-text--clamped': _ctx.clamped}])
    }, null, 8, ["value", "full", "class"]),
    (!_ctx.showsAll)
      ? (_openBlock(), _createBlock(_component_v_menu, {
          key: 0,
          location: "bottom end",
          "close-on-content-click": false
        }, {
          activator: _withCtx(({props: menuProps}) => [
            _createVNode(_component_v_btn, _mergeProps(menuProps, {
              icon: "mdi-arrow-expand",
              size: "x-small",
              variant: "text",
              density: "comfortable",
              class: "no-drag",
              title: _ctx.$tt('expand'),
              "aria-label": _ctx.$tt('expand'),
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }), null, 16, ["title", "aria-label"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "md-expandable-popover" }, {
              default: _withCtx(() => [
                _createVNode(_component_markdown_viewer, { initialValue: _ctx.value }, null, 8, ["initialValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}